import { Col, Row } from "antd";
import { get, set } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineFrontHand, MdOutlinePinDrop } from "react-icons/md";
import Alert from "shared/components/Alert";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import { filterContractNumber } from "utils/helpers/validations";

const TerminationRequest = ({
  initialValues,
  setPercent,
  bindField,
  isFieldRequired,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });

  const contractNumberPath = "project.terminationRequest.contractNumber";
  const contractNumberField = bindField(contractNumberPath, {
    label: SUBSCRIPTION.FORM.CONTRACT_NUMBER.LABEL,
    required: isFieldRequired(contractNumberPath),
    extractValue: ({ target: { value } }) => filterContractNumber(value),
    onBlur: () => setPercent(initialValues),
  });

  const addressPath = "project.terminationRequest.address";
  const addressField = bindField(addressPath, {
    label: SUBSCRIPTION.FORM.CURRENT_COMPANY_ADDRESS.LABEL,
    required: isFieldRequired(addressPath),
    onBlur: () => setPercent(initialValues),
  });

  return (
    get(initialValues, "project.ria", false) && (
      <div
        className="subscription-form--wrapper"
        id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.TERMINATION_REQUEST}-section`}
      >
        <Form
          type="vertical"
          title={
            SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.TERMINATION_REQUEST.TITLE
          }
          subtitle={
            SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.TERMINATION_REQUEST
              .SUBTITLE
          }
        >
          <Row gutter={[16, 16]}>
            <Col lg={24} xs={24}>
              <Alert
                showIcon
                type="info"
                message={SUBSCRIPTION.FORM.TERMINATION_ALERT}
              />
            </Col>
            <Col lg={24} xs={24}>
              <FormField
                path={contractNumberField.path}
                label={contractNumberField.label}
                required={contractNumberField.required}
                disabled={contractNumberField.disabled}
              >
                {(field) => (
                  <Input
                    placeholder={SUBSCRIPTION.FORM.CONTRACT_NUMBER.PLACEHOLDER}
                    label={contractNumberField.label}
                    icon={<MdOutlineFrontHand size={16} />}
                    type="custom"
                    stripSpaces={true}
                    defaultValue={contractNumberField.defaultValue}
                    {...field}
                    onChange={contractNumberField.onChange}
                    onBlur={contractNumberField.onBlur}
                  />
                )}
              </FormField>
            </Col>
            <Col lg={24} xs={24}>
              <FormField
                path={addressField.path}
                label={addressField.label}
                required={addressField.required}
                disabled={addressField.disabled}
              >
                {(field) => (
                  <Input
                    optional={SUBSCRIPTION.FORM.OPTIONAL}
                    placeholder={
                      SUBSCRIPTION.FORM.CURRENT_COMPANY_ADDRESS.PLACEHOLDER
                    }
                    label={addressField.label}
                    icon={<MdOutlinePinDrop size={16} />}
                    type="custom"
                    normalizeText={true}
                    defaultValue={addressField.defaultValue}
                    {...field}
                    onChange={addressField.onChange}
                    onBlur={addressField.onBlur}
                  />
                )}
              </FormField>
            </Col>
          </Row>
        </Form>
      </div>
    )
  );
};

export default TerminationRequest;
